import React from 'react';
import {
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    SelectChangeEvent,
    Stack,
    Typography
} from "@mui/material";
import {SelectsWrapper} from "./ModelConfiguration.styled";
import {useTranslation} from "react-i18next";
import {Model} from "../../../../../models/admin-config.models";

interface ModelConfigurationProps {
    availableModels: Model[];
    defaultModel: Model;
    handleModelChange: (event: SelectChangeEvent<number>) => Promise<void> | void;
}

const ModelConfiguration = ({
    availableModels,
    defaultModel,
    handleModelChange
}: ModelConfigurationProps) => {
    const {t} = useTranslation();

    return (
        <Stack direction='column' spacing={4}>
            <Typography variant='body1'>
                {t('configuration.modelTitle')}
            </Typography>

            <Stack direction='column' spacing={2}>
                <SelectsWrapper>
                    <FormControl
                        sx={{
                            width: '100%',
                            '@media (min-width: 760px)': {
                                width: 265,
                            },
                            '& .MuiInputLabel-root': {
                                top: '-3px',
                            },
                        }}
                    >
                        <InputLabel id="model-select-label">
                            {t('configuration.modelsList')}
                        </InputLabel>

                        <Select
                            id="model-select"
                            labelId="model-select-label"
                            value={defaultModel.id ?? ''}
                            onChange={handleModelChange}
                            input={<OutlinedInput label={t('configuration.modelsList')} />}
                            sx={{
                                borderRadius: '16px',
                                '.MuiSelect-select': {
                                    padding: '12px 13px',
                                },
                            }}
                            renderValue={selected => {
                                if (!selected) return t('configuration.selectModel');
                                return (
                                    availableModels.find(m => m.id === selected)?.displayName ?? ''
                                );
                            }}
                        >
                            {availableModels.map(option => (
                                <MenuItem key={option.id} value={option.id}>
                                    <ListItemText
                                        primary={option.displayName}
                                        secondary={t(option.description)}
                                    />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </SelectsWrapper>

                <Typography variant={'body2'} color="text.secondary">
                    {t('configuration.modelDescription')}
                </Typography>
            </Stack>
        </Stack>
    );
};

export default ModelConfiguration;